import { createAction, props } from '@ngrx/store';

export const loadProofOfBankDocumentTypes = createAction('[ProofOfBankDocumentTypes] Load ProofOfBankDocumentTypes');

export const loadProofOfBankDocumentTypesSuccess = createAction('[ProofOfBankDocumentTypes] Load ProofOfBankDocumentTypes Success', props<{ response: any }>());

export const loadProofOfBankDocumentTypesFailure = createAction('[ProofOfBankDocumentTypes] Load ProofOfBankDocumentTypes Failure', props<{ error: Error | any }>());